import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import PropTypes from 'prop-types';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import Text from '@zenbusiness/zui/Text';

import { CLICKSTREAM_COMMON_PROPS } from '#client/components/utils/constants';

import * as Styled from './IdeaCard.style';

/**
 * Individual business idea card component
 * @param {object} props - Component props
 * @param {object} props.idea - Business idea data
 * @param {boolean} [props.selected=false] - Whether this idea is selected
 * @param {Function} props.onClick - Click handler for idea selection
 */
function IdeaCard({ idea, selected = false, onClick }) {
  const handleLinkPressed = useClickstreamCallback('linkPressed', {
    ...CLICKSTREAM_COMMON_PROPS,
    elementName: 'business_idea_select',
    elementText: idea.title
  });

  const handleClick = () => {
    if (onClick) {
      handleLinkPressed();
      onClick(idea.id);
    }
  };

  return (
    <Styled.IdeaCardRoot
      aria-pressed={selected}
      role="button"
      selected={selected}
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <Text selected={selected} size="sm" weight="medium">
        {idea.title}
      </Text>
      <KeyboardArrowRightIcon fontSize="small" />
    </Styled.IdeaCardRoot>
  );
}

IdeaCard.propTypes = {
  idea: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string // Backward compatibility
  }).isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func
};

export default IdeaCard;
